export default __webpack_public_path__ + "static/media/Routine.a8dfa6ded368f5fd0db7949c609e3c3d.webp";